import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-order-history-record-skeleton',
  templateUrl: './order-history-record-skeleton.component.html',
  styleUrl: 'order-history-record-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgxSkeletonLoaderModule,
  ],
})
export class OrderHistoryRecordSkeletonComponent {
}
